const handleFileSelect = (inputFileElement) => {
    const inputFileContainer = inputFileElement.closest('.js-input-file-container');
    const inputFileSelectedFilesPlaceholder = inputFileContainer.querySelector(
        '.js-input-file-selected-files'
    );

    inputFileSelectedFilesPlaceholder.textContent = [...inputFileElement.files]
        .map((file) => `${file.name} (${Math.round(file.size / 1000)}KB)`)
        .join(', ');

    console.log(inputFileElement.files);
};

export const inputFileListener = () => {
    const inputFileElements = [...document.querySelectorAll('.js-input-file')].filter(
        (el) => !el.dataset.inputFileInitialized
    );

    inputFileElements.forEach((el) => {
        el.addEventListener('change', () => {
            handleFileSelect(el);
        });

        el.dataset.inputFileInitialized = true;
    });
};
